module.exports = __webpack_public_path__ + "img/moobyyoho.dd0f7262.png";